import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
`;

export const DescriptionBoxPlan = styled.div`
  padding: 25px 25px 0 25px;
  text-align: start;

  .tag-popularity {
    position: absolute;
    top: 23px;
    right: -2px;
  }

  .logo-description {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    span {
      font-size: 24px;
      font-weight: 700;
      line-height: 26px;
      color: ${({theme}) => theme.colors.surface.onSurface};
      margin-left: 5px;
    }
  }
`;

export const Main = styled.div`
  height: 100%;
  padding: 25px 25px 0 25px;
  overflow-y: auto;

  span {
    font-size: 12px;
    font-weight: 400;
    color: ${({theme}) => theme.colors.surface.onSurfaceVariant};
    line-height: 16px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 21px 0;

  .price-box-plan {
    padding: 0 25px;
    display: flex;
    justify-content: center;

    .price-box {
      display: flex;
    }

    .price-text {
      font-size: 24px;
      font-weight: 600;
      color: ${({theme}) => theme.colors.surface.onSurface};
    }

    .price-custom {
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: ${({theme}) => theme.colors.surface.onSurfaceVariant};
    }

    .price-text-last {
      align-self: flex-end;
      margin-left: 5px;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 400;
      color: ${({theme}) => theme.colors.surface.onSurfaceVariant};
    }
  }

  .button-box-plan {
    margin: 15px 25px 0 25px;

    .button-plan {
      width: 100%;
      border-radius: 5px;
    }

    .button-custom-plan {
      width: 100%;
      border-radius: 5px;
      cursor: pointer;
    }
  }
`;

interface ISeparator {
  margintop?: number;
  marginbottom?: number;
}

export const Separator = styled.div<ISeparator>`
  width: 100%;
  height: 1px;
  background-color: ${({theme}) => theme.colors.surface.surfaceOutline};
  margin-top: ${({margintop}) => margintop || 25}px;
  margin-bottom: ${({marginbottom}) => marginbottom || 0}px;
`;
